<hs-no-loaded-account [content]="loadedAccountDependentContent">
</hs-no-loaded-account>

<ng-template #loadedAccountDependentContent>
  <hs-cache-load-listener
    [content]="cacheDependentContent"
    [sessionCacheStatus]="sessionCacheStatus"
    [sessionId]="lastProcessedSessionId"
    [accountIds]="lastProcessedAccountIds"
    [notApplicable]="notApplicable"
    [notApplicableMessage]="notApplicableMessage"
  ></hs-cache-load-listener>
</ng-template>

<ng-template #cacheDependentContent>
  <hs-external-transactions-grid
    [cacheLoadStatus]="sessionCacheStatus"
    [securityIdFilter]="securityIdFilter | async"
    [currencyFilter]="currencyFilter | async"
    [rowsUpdated]="updatedExternalTransactions | async"
    [filteredMatchedExtTranIds]="extTranIdFilter | async"
    [focusedExtTranId]="focusedExtTranId$ | async"
    [focusedExtTranIds]="focusedExtTranIds$ | async"
    [selectedCwTrans]="selectedCwTrans"
    (externalTransactionsSelected)="onExternalTransactionsSelected($event)"
  ></hs-external-transactions-grid>
</ng-template>
